export const mobileSteps = [
  'Активуйте "Миттєвий переказ", якщо він доступний при оплаті в додатку банку (кошти швидше зарахуються).',
  'Не використовуйте функцію «Повторити платіж» у банківському застосунку (кошти не зарахуються).',
  'Для кожного поповнення потрібно створювати нову транзакцію на сайті.',
  'Для нового поповнення потрібно згенерувати новий QR-код (створити нову транзакцію).',
];

export const desktopSteps = [
  'Відкрийте банківський застосунок і відскануйте QR-код в цьому додатку.',
  'Активуйте "Миттєвий переказ", якщо він доступний при оплаті в додатку банку(кошти швидше зарахуються).',
  'Не використовуйте функцію «Повторити платіж» у банківському застосунку (кошти не зарахуються).',
  'Для нового поповнення потрібно згенерувати новий QR-код (створити нову транзакцію).',
];
